import axios from "axios";

export default {
  state: {
    client: null
  },
  mutations: {
    SET_CLIENT ( state, client ) {
      state.client = client;
    },
  },
  actions: {
    GET_CLIENT: async ( context, clientId ) => {
      context.commit('SET_CLIENT', false);
      let { data } = await axios.get( '/clients/' + clientId )
      context.commit('SET_CLIENT', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_CLIENT ( { commit }, client ) {
      commit( 'SET_CLIENT', client );
    }
  },
}
